import { gql, useApolloClient } from '@apollo/client';
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { CourseTypeBoxFragment } from './__queries__';

const Wrapper = styled.div`
  background: ${(props) => props.color ?? '#a7a7a7'};
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50%;
  height: 24px;
  aspect-ratio: 1;
  color: var(--colorBlueGray1200);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
`;

interface Props {
  id: string;
}

const CourseTypeBox: React.FunctionComponent<Props> = ({ id }) => {
  const client = useApolloClient();

  const courseType = useMemo(() => {
    try {
      return client.readFragment<CourseTypeBoxFragment>({
        id,
        fragment: gql`
          fragment CourseTypeBoxFragment on CourseType {
            id
            color
            label
          }
        `,
      });
    } catch (e) {
      return null;
    }
  }, [id]);

  return <Wrapper color={courseType?.color}>{courseType ? courseType.label : '??'}</Wrapper>;
};

export default CourseTypeBox;
